module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'documents',
		'invoice',
		'costCenters',
		'table',
	],

	model: {
		invertFields: [
			'hourlyRate',
			'hourlyRateCoretime',
			'hourlyRateCoretimeCommissionInclusive',
			'hourlyRateOvertimePremium',
			'hourlyRateOvertimePremiumCommissionInclusive',
			'netPrice',
			'netPriceCommission',
			'netPriceMain',
			'netPriceOvertimePremium',
			'netPriceOvertimePremiumCommissionInclusive',
			'price',
		]
	},

	methods: {

		sanitizeEntity: function(refEntity, refPrevEntity){
			refEntity.attributes = refEntity.attributes || {}
			refEntity.meta = refEntity.meta || {}
			const projectTermID = ((refEntity.attributes || {}).projectTerm || {}).projectTermID
			const prevProjectTermID = (((refPrevEntity || {}).attributes || {}).projectTerm || {}).projectTermID

			refEntity.meta.hasGroupRow =
				!refPrevEntity ||
				(projectTermID && prevProjectTermID && projectTermID != prevProjectTermID) ||
				(!projectTermID && prevProjectTermID) ||
				(projectTermID && !prevProjectTermID)

			for(const attribute of this.model.invertFields){
				refEntity.attributes[attribute] = (refEntity.attributes[attribute] || 0) * -1
			}

			if(refEntity.attributes.overtime){
				refEntity.attributes.overtime.netPriceOvertimePremium 						= (refEntity.attributes.overtime.netPriceOvertimePremium || 0) * -1
				refEntity.attributes.overtime.netPriceOvertimePremiumCommissionInclusive 	= (refEntity.attributes.overtime.netPriceOvertimePremiumCommissionInclusive || 0) * -1
				refEntity.attributes.overtime.hourlyRateOvertimePremium 					= (refEntity.attributes.overtime.hourlyRateOvertimePremium || 0) * -1
				refEntity.attributes.overtime.hourlyRateOvertimePremiumCommissionInclusive 	= (refEntity.attributes.overtime.hourlyRateOvertimePremiumCommissionInclusive || 0) * -1
			}
		},
	},
}